export const skillsData = [
    {
        label: "Programming Languages",
        data: [
            {
                skillName: "Java",
                percentage: "85",  // Adjust percentage as needed
            },
            {
                skillName: "JavaScript",
                percentage: "90",  // Adjust percentage as needed
            },
            {
                skillName: "HTML",
                percentage: "90",  // Adjust percentage as needed
            },
            {
                skillName: "CSS",
                percentage: "80",  // Adjust percentage as needed
            },
        ],
    },
    {
        label: "Frameworks & Libraries",
        data: [
            {
                skillName: "React",
                percentage: "85",  // Adjust percentage as needed
            },
        ],
    },
    {
        label: "Database Management",
        data: [
            {
                skillName: "MongoDB",
                percentage: "55",  // Adjust percentage as needed
            },
            {
                skillName: "MySQL",
                percentage: "70",  // Adjust percentage as needed
            },
            {
                skillName: "SQL",
                percentage: "80",  // Adjust percentage as needed
            },
        ],
    },
    {
        label: "Tools & Software",
        data: [
            {
                skillName: "Postman",
                percentage: "60",  // Adjust percentage as needed
            },
            {
                skillName: "Arduino IDE",
                percentage: "45",  // Adjust percentage as needed
            },
            {
                skillName: "AutoDesk Fusion 360",
                percentage: "30",  // Adjust percentage as needed
            },
            {
                skillName: "GitHub",
                percentage: "80",  // Adjust percentage as needed
            },
            {
                skillName: "Visual Studio",
                percentage: "75",  // Adjust percentage as needed
            },
            {
                skillName: "Eclipse IDE",
                percentage: "50",  // Adjust percentage as needed
            },
            {
                skillName: "Git",
                percentage: "85",  // Adjust percentage as needed
            },
            {
                skillName: "Linux (Basics)",
                percentage: "60",  // Adjust percentage as needed
            },
        ],
    },
    {
        label: "Design Skills",
        data: [
            {
                skillName: "UX Design",
                percentage: "70",  // Adjust percentage as needed
            },
            {
                skillName: "Visual Design",
                percentage: "75",  // Adjust percentage as needed
            },
            {
                skillName: "Poster Making",
                percentage: "65",  // Adjust percentage as needed
            },
        ],
    },
    {
        label: "Design Tools",
        data: [
            {
                skillName: "Figma",
                percentage: "80",  // Adjust percentage as needed
            },
            {
                skillName: "Canva",
                percentage: "95",  // Adjust percentage as needed
            },
        ],
    }
];
